import type { AuthenticatedUser, Permission } from '#shared/types';

/**
 * What the signed-in user may do, for deciding what to *offer*.
 *
 * Presentation only — hiding a button is not authorisation. The keys are the
 * catalog in `shared/permissions.ts`, the server enforces each one, and the
 * user's set arrives already resolved (role, plus allows, minus denies) from
 * `GET /auth/me`. Nothing here decides who may do what; the roles screen does.
 */
export function can(user: AuthenticatedUser | null, capability: Permission): boolean {
  return user ? user.permissions.includes(capability) : false;
}
